import React from 'react'
import { Row, Col, Space, Form, Input, Button, Select, TreeSelect, Spin } from 'antd'
import { reqPopExpSamples } from '../../../api'

import './dendrogram.css'
import './expressMap.css'

const { TextArea } = Input
const { Option } = Select

class PopExpression extends React.Component {
    state = {
        samples_data: '',
        disabled: false,
        spinning: false,
    }

    formRef = React.createRef()

    onFinish = (values) => {
        this.setState({
            disabled: true,
            spinning: true,
        })

        let { geneids, population, tissue, samples } = values
        geneids = geneids.replace(/[\r\n]/g, ",")
        let glist = geneids.split(',')
       
        const BatchGeneExpression = window.BatchGeneExpression
        BatchGeneExpression.cotton_dev_searchById('expression_heatmap', glist, samples, ()=>this.setState({disabled: false, spinning: false}), 'pop')
    }

    setExampleIDs = () => {
        this.formRef.current.setFieldsValue({ 
            geneids: 'Sopim_BGV006775_00T000010.1,Sopim_BGV006775_00T000041.1,Sopim_BGV006775_00T000082.1,Sopim_BGV006775_00T000095.1,Sopim_BGV006775_00T000126.1,Sopim_BGV006775_00T000133.1,Sopim_BGV006775_00T000134.1,Sopim_BGV006775_01T000083.1,Sopim_BGV006775_01T000084.1,Sopim_BGV006775_01T000087.1'
        })

        return false
    }

    onReset = () => {
        this.formRef.current.resetFields()
    }

    async componentDidMount() {
        const samples_res = await reqPopExpSamples()
        let samples_data = ''
        if (samples_res.code === 0) {
            samples_data = samples_res.data
        }
        
        this.setState({
            samples_data: samples_data
        })
    }

    render() {
        const { samples_data, disabled, spinning } = this.state

        const layout = {
            labelCol: {
                md: { span: 4 },
                xxl: { span: 3 }
            },
            wrapperCol: { span: 6 },
            colon: false
        }

        const tailLayout = {
            wrapperCol: {
                md: { offset: 4, span: 12 },
                xxl: { offset: 3, span: 12 }
            },
        }

        const geneids_label = <span className="example_ids">Gene IDs (<a onClick={this.setExampleIDs}>Try Example</a>)</span>

        return (
            <React.Fragment>
                <Form {...layout} labelAlign="left" name="pop-expression" ref={this.formRef} className="pop-expression-form" onFinish={this.onFinish}>
                    <Form.Item name="geneids" label={geneids_label} rules={[{ required: true }]} initialValue="" wrapperCol={{span: 20}}>
                        <TextArea rows={8} placeholder="Enter Gene IDs here, separate genes with comma or new line. Limited to 50 entries for better presentation."></TextArea>
                    </Form.Item>
                    <Form.Item name="population" label="Select population" initialValue="Pop332">
                        <Select showArrow allowClear onChange={this.onPopulationChange}>
                            <Option value="Pop332">Pop332</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="tissue" label="Select tissue" initialValue="">
                        <Select showArrow allowClear onChange={this.onTissueChange}>
                            <Option value=""></Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="samples" label="Select samples" rules={[{ required: true }]} wrapperCol={{span: 24}}>
                        <TreeSelect
                            style={{ width: '40%' }}
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            treeData={ samples_data }
                            placeholder="Please select samples. At least 2 samples needed."
                            onChange={this.onTreeSelectChange}
                            multiple
                            showSearch
                            treeCheckable={true}
                        />
                    </Form.Item>
                    <Form.Item {...tailLayout}>
                        <Row>
                            <Col span={12}>
                                <Space>
                                    <Button type="primary" disabled={disabled} htmlType="submit" block>
                                        Submit
                                    </Button>
                                    <Button htmlType="button" disabled={disabled} onClick={this.onReset}>
                                        Reset
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
                <Row>
                    <Col span={24}>
                        <div className="expression-heatmap-spin"><Spin size="large" spinning={spinning} /></div>
                        <div id="expression_heatmap"></div>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default PopExpression
